import React from "react";
import { FullRow, Row, Col } from "../../framework/Grid";
import AcquireWebComponent from "../../framework/MaterialUI";
import AudInputField from "../../framework/InputField/InputField";
import { getUrlParameterByName, lo } from "../../../utils/utility";
import localSegmentSelection from "../../../utils/localSegmentSelecttion";
import { uiBuildNumber } from "../../../env";

import { RaisedButton } from "material-ui";
import { isObject, isEmpty } from "lodash";
import "../auth.css";

import "rc-tooltip/assets/bootstrap_white.css";

class Login extends AcquireWebComponent {
  constructor(props) {
    super(props);
    props.handleLogout();
    window.localStorage.removeItem("session");
    window.localStorage.removeItem("session_timestamp");
    window.localStorage.clear();

    localSegmentSelection.clearLocalData();
  }

  updateDimensions() {
    this.setState({
      height: window.innerHeight + "px",
      topPadding: (window.innerHeight - 480) / 4 + "px",
      footerTop: (window.innerHeight - 480) / 2 - 80 + "px",
    });
  }

  retrieveSession(session) {
    this.session = JSON.parse(session);
  }

  getTokenAfterLogin() {
    if (this.props.token) {
      return {
        key: "session",
        val: {
          loginTime: new Date(),
          token: this.props.token,
          userId: this.props.userId,
          roleId: this.props.roleId,
          roleName: this.props.roleName,
          apiBuildNumber: this.props.apiBuildNumber,
          tokenExpirationTime: this.props.tokenExpirationTime,
        },
      };
    }
    return null;
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.handleContinue();
    }
  }

  handlePasswordKeyPress(e) {
    if (e.key === "Enter") {
      this.handleLogin();
    }
  }

  componentWillMount() {
    this.updateDimensions();
    this.setState({
      usernameTooltip: undefined,
      passwordTooltip: undefined,
      pwdInputOpacity: 0,
      unameInputOpacity: 1,
      username: "",
      inputMode: "username",
      apiBuildNumber: undefined,
      submit: false,
    });
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions.bind(this));
    if (isObject(this.session)) {
      this.props.mountSession(this.session);
    } else {
      this.session = {};
      this.props.handleLogout();
      window.localStorage.clear();
    }
    this.usernameInput.refs.inputRef.focus();
    if (!this.props.apiBuildNumber) {
      this.props.getAPIBuildNumber();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.loggedIn === true &&
      this.props.loggedIn !== nextProps.loggedIn
    ) {
      this.session = {
        key: "session",
        val: {
          loginTime: new Date(),
          token: nextProps.token,
          userId: nextProps.userId,
          roleId: nextProps.roleId,
          roleName: nextProps.roleName,
          apiBuildNumber: nextProps.apiBuildNumber,
          tokenExpirationTime: nextProps.tokenExpirationTime,
        },
      };
      this.props.mountSession(this.session);
      setTimeout(function () {
        const redirectUrl = getUrlParameterByName("redirect");
        if (
          !isEmpty(redirectUrl) &&
          redirectUrl.indexOf("/insights/audience") >= 0
        ) {
          window.location = redirectUrl;
        } else {
          window.location = "/";
        }
      }, 1000);
    } else {
      if (nextProps.loginErrorMessage) {
        this.setState({ submit: false });
      }
    }
  }

  handleUsernameChanged(e, value) {
    const uname = value.trim();
    if (uname === "") {
      this.setState({
        usernameTooltip: "Please enter an Email or Username",
        username: "",
      });
    } else {
      this.setState({
        usernameTooltip: undefined,
        username: uname,
      });
    }
  }

  handlePasswordChanged(e, value) {
    const pwd = value.trim();
    if (pwd === "" || pwd === undefined) {
      this.setState({
        passwordTooltip: "Please enter your password",
        password: undefined,
      });
    } else
      this.setState({
        password: pwd,
        passwordTooltip: undefined,
      });
  }

  handleContinue() {
    //this.btnContinue.refs.container.button.focus()
    this.passwordInput.refs.inputRef.focus();
    if (this.state.username.trim() === "") {
      this.setState({
        usernameTooltip: "Please enter an Email or Username",
      });
      setTimeout(
        function () {
          this.usernameInput.refs.inputRef.focus();
        }.bind(this),
        20,
      );
      return;
    }
    this.setState({ inputMode: "password", usernameTooltip: undefined });
    setTimeout(
      function () {
        this.setState({
          pwdInputOpacity: 1,
        });
        this.passwordInput.refs.inputRef.focus();
      }.bind(this),
      20,
    );
  }

  handleUpdateUserName(e) {
    e.preventDefault();
    this.setState({
      inputMode: "username",
      password: "",
      pwdInputOpacity: 0,
      usernameTooltip: undefined,
      passwordTooltip: undefined,
    });
  }

  handleLogin() {
    this.setState({
      submit: true,
    });
    this.btnLogin.refs.container.button.focus();
    const password = this.state.password;
    if (password === "" || password === undefined) {
      this.setState({
        passwordTooltip: "Please enter your password",
      });
      setTimeout(
        function () {
          this.passwordInput.refs.inputRef.focus();
        }.bind(this),
        20,
      );
      return;
    } else {
      this.setState({
        passwordTooltip: undefined,
      });
      this.props.handleLoginSubmit(this.state.username, this.state.password);
    }
  }

  displayErrorMessage() {
    const error = getUrlParameterByName("error");
    if ((this.props.loginErrorMessage || error) && !this.state.submit) {
      return (
        <div className="rc-tooltip-content">
          <div
            className="rc-tooltip-inner mb-20"
            style={{ borderColor: "#000", backgroundColor: "#EBEBEB" }}
          >
            <div style={{ color: "red" }}>
              {this.props.loginErrorMessage
                ? this.props.loginErrorMessage
                : error}{" "}
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  render() {
    const { apiBuildNumber } = this.props;
    return (
      <Row
        className="login-container"
        style={{
          height: this.state.height,
          paddingTop: this.state.topPadding,
          fontSize: "16px",
        }}
      >
        <Col
          xs="4"
          sm="4"
          md="4"
          lg="4"
          offsetXs="4"
          offsetSm="4"
          offsetLg="4"
          offsetMd="4"
        >
          <FullRow className="text-center" style={{ marginBottom: "-10px" }}>
            <div className="login-form" style={{ width: "400px" }}>
              <FullRow className="text-center no-padding no-margin-bottom">
                <img
                  alt=""
                  src="/images/logo.png"
                  style={{ display: "inline-table", height: "48px" }}
                />
                <hr style={{ borderTop: "solid 1px #000" }} />
              </FullRow>
              <div className="pl-20 pr-20">
                <div
                  style={{
                    color: "#000000",
                    textAlign: "left",
                    marginBottom: "10px",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Sign in
                </div>
                {this.displayErrorMessage()}
                <div
                  style={{
                    color: "#000000",
                    marginBottom: "-10px",
                    marginTop: "20px",
                  }}
                  className="text-left"
                >
                  Email
                </div>
                <AudInputField
                  ref={(input) => {
                    this.usernameInput = input;
                  }}
                  labelTitle=""
                  key="usernameInputField"
                  toolTipContent={this.state.usernameTooltip}
                  onChange={(e, value) => this.handleUsernameChanged(e, value)}
                  initValue={this.state.username}
                  hintText="Enter Email or Username"
                  /*style={{display: this.state.inputMode === "username" ? "block":"none"}}*/
                  onKeyDown={(e) => this.handleKeyPress(e)}
                />
                {/*
								<div className="input-div" style={{display: this.state.inputMode === "password" ? "block":"none"}}>
									{this.state.username}
									<div className="pull-right">
										<a onClick={this.handleUpdateUserName.bind(this)}>
											<ContentCreate style={{color:primaryColor(), height:"20px", width:"20px"}} />
										</a>
									</div>
									</div>*/}
                <div
                  style={{
                    color: "#000000",
                    marginBottom: "-10px",
                    marginTop: "20px",
                  }}
                  className="text-left"
                >
                  Password
                </div>
                <AudInputField
                  ref={(input) => {
                    this.passwordInput = input;
                  }}
                  labelTitle=""
                  key="passwordInputField"
                  toolTipContent={this.state.passwordTooltip}
                  onChange={(e, value) => this.handlePasswordChanged(e, value)}
                  initValue={this.state.password}
                  hintText="Enter your password"
                  inputType="password"
                  onKeyDown={(e) => this.handlePasswordKeyPress(e)}
                  /*style={{display: this.state.inputMode === "password" ? "block":"none", opacity: this.state.pwdInputOpacity}}*/
                />
              </div>

              <RaisedButton
                ref={(input) => {
                  this.btnLogin = input;
                }}
                backgroundColor="#F56600"
                key="btn-login"
                labelColor="#FFF"
                onClick={this.handleLogin.bind(this)}
                disabled={
                  isEmpty(this.state.username) ||
                  isEmpty(this.state.password) ||
                  this.state.submit
                }
                style={{
                  backgroundColor: "#F56600",
                  marginTop: "10px",
                  marginBottom: "10px",
                  textTransform: "capitalize",
                  fontFamily: "Arial",
                }}
                label="Sign In"
              />
              {this.state.submit && (
                <span
                  style={{
                    position: "absolute",
                    bottom: "100px",
                    right: "185px",
                  }}
                >
                  <img style={{ width: "25px" }} src="/Spinner.gif" alt="" />
                </span>
              )}
              <hr style={{ borderTop: "solid 1px #000" }} />
              <div className="text-right">
                <a className="link-with-white" href="/resetpassword">
                  Can't sign in?
                </a>
              </div>
            </div>
          </FullRow>
          <div className="text-center mt-20" style={{ color: "#FFFFFF" }}>
            <a
              className="link-color-white"
              target="_blank"
              href="https://www.claritas.com/sites/default/files/files/Claritas%20Comprehensive%20Privacy%20Policy%20-%20Jan%202019.pdf"
            >
              Privacy Policy
            </a>{" "}
            - <span className="link-color-white">Terms of use</span>
            <div className="mt-20 mb-20">
              <a href="https://www.claritas.com/" target="_blank">
                <img
                  alt=""
                  src="/images/claritas-logo.png"
                  style={{ display: "inline-table", height: "28px" }}
                />
              </a>
            </div>
            <div>Copyright © 2019 Claritas, LLC. All rights reserved. </div>
          </div>
        </Col>
        <Col xs="12" sm="12" md="12" lg="12">
          {uiBuildNumber && apiBuildNumber && (
            <span
              className="pull-right text-right"
              style={{
                fontSize: "0.6em",
                position: "absolute",
                right: "20",
                top: this.state.footerTop,
              }}
            >
              <small>UI Build #{uiBuildNumber}</small>
              <br />
              <small>API Build #{apiBuildNumber}</small>
            </span>
          )}
        </Col>
      </Row>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Auth/Login/index.jsx